import axios from 'axios';
import utils from '../utils/index.js'
import router from '../router'
import store from '../store/index.js';

var api = {};

var baseUrl = "/api";

var RES_COUNT = 0;
axios.interceptors.request.use((config) => {
  if (config.apiType == 1) {
    return config;
  }
  RES_COUNT++;
  store.commit('CHANGE_COUNT', RES_COUNT);
  return new Promise((resolve, reject) => {
    resolve(config)
  });
}, (error) => {
  RES_COUNT > 0 && RES_COUNT--;
  store.commit('CHANGE_COUNT', RES_COUNT);
  utils.toast(error.message || "请求失败", 2000);
});

axios.interceptors.response.use((response) => {
  if (response && response.config && response.config.apiType && response.config.apiType == 1) {
    return response;
  }
  RES_COUNT > 0 && RES_COUNT--;
  store.commit('CHANGE_COUNT', RES_COUNT);
  return new Promise((resolve, reject) => {
    if (!response.request.responseType) {
      if (response && response.headers && response.headers["content-type"] == "application/force-download;charset=UTF-8") {
        resolve(response);
      } else if (response.data && response.data.code == 0) {
        resolve(response);
      } else if (response.data && response.data.code === '16010004') {
        utils.clearCookie('userToken');
        axios.defaults.headers.common['token'] = '';
        const fullPath = router.currentRoute.fullPath;
        store.commit('CHANGE_IsShow', false);
        router.push({
          name: 'login',
          query: {
            redirect: fullPath
          }
        })
      } else if (response.data && response.data.code.indexOf("16") > -1) {
        reject(response.data);
      } else {
        //utils.toast(response.data.message || "请求失败", 2000);
        resolve(response);
      }
    } else {
      resolve(response);
    }
  })
}, (error) => {
  console.log(error.response)
  RES_COUNT > 0 && RES_COUNT--;
  store.commit('CHANGE_COUNT', RES_COUNT);
  router.push({ name: 'login' })
  return Promise.reject(error)
  //utils.toast(error.message || "请求失败", 2000);
});

var instance = axios.create({
  headers: {
    'content-type': 'application/x-www-form-urlencoded'
  }
});

// 头部信息
api.initHeader = function () {
  axios.defaults.headers.common['device_id'] = utils.getDeviceId();
  axios.defaults.headers.common['platform'] = utils.platform();
  var userToken = utils.getCookie("userToken");
  if (userToken) {
    axios.defaults.headers.common['token'] = userToken;
  } else {
    axios.defaults.headers.common['token'] = '';
  }
}

//OA登陆陆模块——登陆接口——李辉
api.LHLogin = function (data) {
  var url = baseUrl + "/oabase/login/login";
  return axios.post(url, data);
}

// oa验证手机号与密码是否一致--李辉
api.LHLoginCheckphonecode = function (data) {
  var url = baseUrl + "/oabase/login/checkphonecode";
  return axios.post(url, data);
}

// OA登出接口
api.LHLoginout = function (data) {
  var url = baseUrl + "/oabase/login/loginout";
  return axios.post(url, data);
}

api.ZZDSendLoginStatus = function (data) {
  var url = baseUrl + "/oabase/sys/info/sendloginstatus";
  return axios.post(url, data, { apiType: 1 });
}

//OA登陆陆模块——忘记密码接口——李辉
api.LHForgetpwd = function (data) {
  var url = baseUrl + "/oabase/login/forgetpwd";
  return axios.post(url, data);
}

//OA登陆陆模块——发送短信验证码——李辉
api.LHSendshortmail = function (data) {
  var url = baseUrl + "/oabase/login/sendshortmail";
  return axios.post(url, data);
}

//OA登陆陆模块——用户信息获取接口——李辉
api.LHUserInfo = function (data) {
  var url = baseUrl + "/oabase/login/userInfo";
  return axios.post(url, data);
}

//OA登陆陆模块——用户扫码登陆请求接口——李辉
api.LHGetqrcodeurl = function (data) {
  var url = baseUrl + "/oabase/login/getqrcodeurl";
  return axios.post(url, data);
}

//OA登陆陆模块——用户扫码登陆操做接口——李辉
api.LHPool = function (data) {
  var url = baseUrl + "/oabase/login/pool";
  return axios.post(url, data, { apiType: 1 });
}

//OA登陆陆模块——用户扫码登陆操做接口2——李辉
api.LHScanlogin = function (data) {
  var url = baseUrl + "/oabase/login/scanlogin";
  return axios.post(url, data);
}

//OA系统首页管理——首页接口查询——田果
api.TGIndexAll = function (data) {
  var url = baseUrl + '/oabase/index/all';
  return axios.post(url, data);
}

//OA系统首页管理——首页接口查询——田果
api.TGBulletinList = function (data) {
  var url = baseUrl + '/oabase/index/bulletin/list';
  return axios.post(url, data);
}

//OA系统公告——公告详情管理员权限人员——张振德
api.ZZDABulletinDetail = function (data) {
  var url = baseUrl + '/oabase/admin/bulletin/detail';
  return axios.post(url, data);
}

//OA系统公告——公告列表查询管理权限人员——张振德
api.ZZDABulletinList = function (data) {
  var url = baseUrl + '/oabase/admin/bulletin/list';
  return axios.post(url, data);
}
//OA系统公告——添加公告——张振德
api.ZZDBulletinAdd = function (data) {
  var url = baseUrl + '/oabase/bulletin/add';
  return axios.post(url, data);
}

//OA系统公告——修改公告，包括删除和撤销——张振德
api.ZZDBulletinChange = function (data) {
  var url = baseUrl + '/oabase/bulletin/change';
  return axios.post(url, data);
}

//OA系统公告——公式公告详情普通用户（带上一条下一条）——张振德
api.ZZDBulletinCurrentdetail = function (data) {
  var url = baseUrl + '/oabase/bulletin/currentdetail';
  return axios.post(url, data);
}

//OA系统公告——公示公告详情普通用户——张振德
api.ZZDBulletinDetail = function (data) {
  var url = baseUrl + '/oabase/bulletin/detail';
  return axios.post(url, data);
}

//OA系统公告——公式公告列表查询,普通员工——张振德
api.ZZDBulletinList = function (data) {
  var url = baseUrl + '/oabase/bulletin/list';
  return axios.post(url, data);
}

//OA系统公告——公告所有节点信息查询——张振德
api.ZZDBulletinOrgnode = function (data) {
  var url = baseUrl + '/oabase/bulletin/orgnode';
  return axios.post(url, data);
}

//OA系统公告——添加公告分类——张振德
api.ZZDBulletinTAdd = function (data) {
  var url = baseUrl + '/oabase/bulletin/type/add';
  return axios.post(url, data);
}

//OA系统公告——删除公告分类——张振德
api.ZZDBulletinTDelete = function (data) {
  var url = baseUrl + '/oabase/bulletin/type/delete';
  return axios.post(url, data);
}

//OA系统公告——公告分类详情查询——张振德
api.ZZDBulletinTDetail = function (data) {
  var url = baseUrl + '/oabase/bulletin/type/detail';
  return axios.post(url, data);
}

//OA系统公告——公告分类列表查询——张振德
api.ZZDBulletinTList = function (data) {
  var url = baseUrl + '/oabase/bulletin/type/list';
  return axios.post(url, data);
}

//OA系统公告——修改公告分类排序——张振德
api.ZZDBulletinTResort = function (data) {
  var url = baseUrl + '/oabase/bulletin/type/resort';
  return axios.post(url, data);
}

//OA系统公告——修改公告分类——张振德
api.ZZDBulletinTUpdate = function (data) {
  var url = baseUrl + '/oabase/bulletin/type/update';
  return axios.post(url, data);
}

//OA系统公告——未读信息数量,普通员工——张振德
api.ZZDBulletinUnreadcount = function (data) {
  var url = baseUrl + '/oabase/bulletin/unreadcount';
  return axios.post(url, data);
}

//OA系统公告——编辑公告——张振德
api.ZZDBulletinUpdate = function (data) {
  var url = baseUrl + '/oabase/bulletin/update';
  return axios.post(url, data);
}

//OA系统公告——数据版本信息查询——张振德
api.ZZDBulletinDVersion = function (data) {
  var url = baseUrl + '/oabase/data/version';
  return axios.post(url, data);
}

// OA系统公告——树结构查询——张振德
api.ZZDNodeSearch = function (data) {
  var url = baseUrl + '/oabase/node/search';
  return axios.post(url, data, { apiType: 1 });
}

// OA系统公告——树结构查询——杨锐(离职人员)
api.ZZDNodeSearchLeave = function (data) {
  var url = baseUrl + '/oabase/node/searchLeave';
  return axios.post(url, data, { apiType: 1 });
}



//OA系统部门管理——部门新增接口——王骁
api.WXOrgAdd = function (data) {
  var url = baseUrl + '/oabase/org/add';
  return axios.post(url, data);
}

//OA系统部门管理——查询通讯录接口——王骁
api.WXOrgAddressBook = function (data) {
  var url = baseUrl + '/oabase/org/addressBook';
  return axios.post(url, data);
}

//OA系统部门管理——根据关键字查询通讯录接口——王骁
api.WXOrgAddressBookS = function (data) {
  var url = baseUrl + '/oabase/org/addressBookSearch';
  return axios.post(url, data, { apiType: 1 });
}

//OA系统部门管理——部门删除接口——王骁
api.WXOrgDelete = function (data) {
  var url = baseUrl + '/oabase/org/delete';
  return axios.post(url, data);
}

//OA系统部门管理——查询部门下级人员接口——王骁
api.WXOrgDepartUser = function (data) {
  var url = baseUrl + '/oabase/org/departUser';
  return axios.post(url, data, { apiType: 1 });
}

//OA系统部门管理——导出EXCEL接口——王骁
api.WXOrgExportMembers = function (data) {
  var url = baseUrl + '/oabase/org/exportMembers';
  return axios.post(url, data, { responseType: 'blob' });
}

//OA系统部门管理——查询部门负责人接口——王骁
api.WXOrgDutyMan = function (data) {
  var url = baseUrl + '/oabase/org/orgDutyMan';
  return axios.post(url, data);
}

//OA系统部门管理——查询部门树接口——王骁
api.WXOrgTree = function (data) {
  var url = baseUrl + '/oabase/org/orgTree';
  return axios.post(url, data);
}

//OA系统部门管理——部门重新排序接口——王骁
api.WXOrgResortDeparts = function (data) {
  var url = baseUrl + '/oabase/org/resortDeparts';
  return axios.post(url, data);
}

//OA系统部门管理——部门编辑接口——王骁
api.WXOrgUpdate = function (data) {
  var url = baseUrl + '/oabase/org/update';
  return axios.post(url, data);
}

//OA系统部门管理——调整人员部门接口——王骁
api.WXOrgUDWithUserRela = function (data) {
  var url = baseUrl + '/oabase/org/updateDepartWithUserRela';
  return axios.post(url, data);
}

//用户相关操作——新增用户——李辉
api.LHUserAdd = function (data) {
  var url = baseUrl + "/oabase/user/add";
  return axios.post(url, data);
}

//用户相关操作——删除用户——李辉
api.LHUserDel = function (data) {
  var url = baseUrl + "/oabase/user/del";
  return axios.post(url, data);
}
//用户相关操作——重置密碼
api.LHUseRes = function (data) {
  var url = baseUrl + "/oabase/user/resetPwd";
  return axios.post(url, data);
}

//用户相关操作——查看相关用户信息——李辉
api.LHUserFinduserinfo = function (data) {
  var url = baseUrl + "/oabase/user/finduserinfo";
  return axios.post(url, data);
}
//用户相关操作——查看相关用户信息——李辉
api.LHUserUpdateuserInfo = function (data) {
  var url = baseUrl + "/oabase/user/updateuserInfo";
  return axios.post(url, data);
}

//OA系统版本管理——版本查询接口——田果
api.TGFindUserInfo = function (data) {
  var url = baseUrl + '/oabase/user/finduserinfo';
}
api.TGVersionList = function (data) {
  var url = baseUrl + '/oabase/version/list';
  return axios.post(url, data);
}

//OA系统版本管理——版本新增接口——田果
api.TGVersionAdd = function (data) {
  var url = baseUrl + '/oabase/version/add';
  return axios.post(url, data);
}

//OA系统版本管理——版本删除接口——田果
api.TGVersionDelete = function (data) {
  var url = baseUrl + '/oabase/version/delete';
  return axios.post(url, data);
}

//OA系统版本管理——版本修改接口——田果
api.TGVersionUpdate = function (data) {
  var url = baseUrl + '/oabase/version/update';
  return axios.post(url, data);
}

//OA系统版本管理——查询app最新版本接口——田果
api.TGVersionNew = function (data) {
  var url = baseUrl + '/oabase/version/new';
  return axios.post(url, data);
}

//OA文件上传--张振德 oabase/utils/common/upload
// OA管理中心-角色列表
api.TGRoleList = function (data) {
  var url = baseUrl + '/oabase/role/list';
  return axios.post(url, data);
}

api.TGCommonUpload = function (type) {
  if (type !== 0) type = type || 1;
  var url = baseUrl + '/oabase/utils/common/upload?system=1&type=' + type;
  return url;
}

api.TGCommonUploadImg = function (data, type) {
  type = type || 1;
  var url = baseUrl + '/oabase/utils/common/upload?system=1&type=1';
  return url;
}
api.TGCommonUpload2 = function (data, type) {
  if (Number(data.size / 1024 / 1024) >= 100) {
    return new Promise(function (res, rej) {
      rej({ message: '文件不能大于100MB' })
    })
  } else {
    if (type !== 0) type = type || 3;
    var url = baseUrl + "/oabase/utils/common/upload?system=1&type=" + type;
    var formFile = new FormData();
    formFile.append("files", data);
    return axios.post(url, formFile, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    });
  }
}

api.TGCommonUploadIE = function (data, type) {
  if (Number(data.size / 1024 / 1024) >= 100) {
    return new Promise(function (res, rej) {
      rej({ message: '文件不能大于100MB' })
    })
  } else {
    if (type !== 0) type = type || 3;
    var url = baseUrl + "/oabase/utils/common/uploadIe?system=1&type=" + type;
    var formFile = new FormData();
    formFile.append("files", data);
    return axios.post(url, formFile, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    });
  }
}

api.WJXZ = function (url) {
  return axios.get(url);
}
// OA管理中心-角色新增
api.TGRoleAdd = function (data) {
  var url = baseUrl + '/oabase/role/add';
  return axios.post(url, data);
}

// OA管理中心-角色编辑
api.TGRoleUpdate = function (data) {
  var url = baseUrl + '/oabase/role/update';
  return axios.post(url, data);
}

// OA管理中心-角色删除
api.TGRoleDelete = function (data) {
  var url = baseUrl + '/oabase/role/delete';
  return axios.post(url, data);
}

// OA管理中心-角色功能菜单接口
api.TGRoleMenu = function (data) {
  var url = baseUrl + '/oabase/role/menu';
  return axios.post(url, data);
}

// OA管理中心-角色新增功能菜单接口
api.TGRoleAddMenu = function (data) {
  var url = baseUrl + '/oabase/role/add/menu';
  return axios.post(url, data);
}

// OA管理中心-角色成员查询接口
api.TGRoleUserList = function (data) {
  var url = baseUrl + '/oabase/role/user/list';
  return axios.post(url, data);
}

// OA管理中心-角色成员添加接口
api.TGRoleUserAdd = function (data) {
  var url = baseUrl + '/oabase/role/user/add';
  return axios.post(url, data);
}

// OA管理中心-角色成员删除接口
api.TGRoleUserDelete = function (data) {
  var url = baseUrl + '/oabase/role/user/delete';
  return axios.post(url, data);
}

// OA管理中心-应用查询接口
api.TGApplicationList = function (data) {
  var url = baseUrl + '/oabase/application/list';
  return axios.post(url, data);
}

// OA管理中心-应用-启用禁用接口
api.TGApplicationDelete = function (data) {
  var url = baseUrl + '/oabase/application/delete';
  return axios.post(url, data);
}

// OA系统-ip地址查询接口
api.ZZDConfigureInfo = function (data) {
  var url = baseUrl + '/oabase/configure/info';
  return axios.post(url, data);
}

// OA系统-ip地址查询接口
api.TGUserMenu = function () {
  var url = baseUrl + '/oabase/user/menu';
  return axios.post(url);
}

// OA系统-ip地址查询接口
api.TGVdownload = function () {
  var url = baseUrl + '/oabase/version/download';
  return axios.post(url);
}

// OA系统-模板导入地址
api.TGVdownload2 = function (data) {
  var url = baseUrl + '/oabase/user/template/';
  return axios.post(url, data, { responseType: 'blob' });
}
// OA系统-用户excel上传接口
api.TGVdownloadexcel = function (data) {
  var url = baseUrl + '/oabase/user/excel/import';
  var formFile = new FormData();
  formFile.append("file", data);
  return axios.post(url, formFile, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }
  });
}
/* ++++++++++++++ OA二期接口 ++++++++++++++*/
// 我已审批列表查询
api.ZZDOaflowForminstanceApprovedlist = function (data) {
  var url = baseUrl + '/oaflow/forminstance/approvedlist';
  return axios.post(url, data);
}

// 待我审批的申请数量
api.ZZDOaflowForminstanceTaskamount = function (data) {
  var url = baseUrl + '/oaflow/forminstance/taskamount';
  return axios.post(url, data,{ apiType: 1 });
}

// 待我审批列表查询
api.ZZDOaflowForminstanceTasklist = function (data) {
  var url = baseUrl + '/oaflow/forminstance/tasklist';
  return axios.post(url, data);
}

// APP审批列表查询接口【田果】
api.TGOaflowForminstanceAppApprovalList = function (data) {
  var url = baseUrl + '/oaflow/forminstance/app/approval/list';
  return axios.post(url, data);
}

// 抄送我的列表查询
api.TGOaflowForminstanceCcList = function (data) {
  var url = baseUrl + '/oaflow/forminstance/cc/list';
  return axios.post(url, data);
}

// 我的申请列表
api.TGOaflowForminstanceMyapplyList = function (data) {
  var url = baseUrl + '/oaflow/forminstance/myapply/list';
  return axios.post(url, data);
}

// 获取最新流程定义详情
api.DCOaflowProcessdefDetail = function (data) {
  var url = baseUrl + '/oaflow/processdef/detail';
  return axios.post(url, data);
}

// 停用流程定义
api.DCOaflowProcessdefDisable = function (data) {
  var url = baseUrl + '/oaflow/processdef/disable';
  return axios.post(url, data);
}

// 启用流程定义
api.DCOaflowProcessdefEnable = function (data) {
  var url = baseUrl + '/oaflow/processdef/enable';
  return axios.post(url, data);
}

// 查看激活的流程定义列表
api.DCOaflowProcessdefListActiveProcessDefine = function (data) {
  var url = baseUrl + '/oaflow/processdef/listActiveProcessDefine';
  return axios.post(url, data);
}

// 查看所有流程定义列表
api.DCOaflowProcessdefListall = function (data) {
  data.condition = data.condition || '';
  var url = baseUrl + `/oaflow/processdef/listall?condition=${data.condition}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`;
  return axios.post(url, data);
}

// 查看挂起的流程定义列表
api.DCOaflowProcessdefListSuspendProcessDefine = function (data) {
  var url = baseUrl + '/oaflow/processdef/listSuspendProcessDefine';
  return axios.post(url, data);
}

// 保存流程定义
api.DCOaflowProcessdefSave = function (data) {
  var url = baseUrl + '/oaflow/processdef/save';
  return axios.post(url, data);
}

// 流程审批通过
api.DCOaflowApprovePass = function (data) {
  var url = baseUrl + '/oaflow/approve/pass';
  return axios.post(url, data);
}

// 流程审批驳回
api.DCOaflowApproveReject = function (data) {
  var url = baseUrl + '/oaflow/approve/reject';
  return axios.post(url, data);
}

// 流程实例撤销
api.DCOaflowApproveRevoke = function (data) {
  var url = baseUrl + '/oaflow/approve/revoke';
  return axios.post(url, data);
}

/*上面是骚货的*/
///oaflow/formgroup/add 添加表单分组
api.QBJformgroupAdd = function (data) {
  var url = baseUrl + '/oaflow/formgroup/add';
  return axios.post(url, data);
}

///oaflow/formgroup/delete 删除表单分组
api.QBJformgroupDelete = function (data) {
  var url = baseUrl + '/oaflow/formgroup/delete';
  return axios.post(url, data);
}

///oaflow/formgroup/list 获取表单分组列表
api.QBJformgroupList = function (data) {
  var url = baseUrl + '/oaflow/formgroup/list';
  return axios.post(url, data);
}

///oaflow/formgroup/sort 表单分组排序
api.QBJformgroupSort = function (data) {
  var url = baseUrl + '/oaflow/formgroup/sort';
  return axios.post(url, data);
}

///oaflow/formgroup/update 更新表单分组
api.QBJformgroupUpdate = function (data) {
  var url = baseUrl + '/oaflow/formgroup/update';
  return axios.post(url, data);
}

///oaflow/forminstance/detail 表单详情
api.QBJforminstanceDetail = function (data) {
  var url = baseUrl + '/oaflow/forminstance/detail';
  return axios.post(url, data);
}

///oaflow/forminstance/search 表单搜索
api.QBJforminstanceSearch = function (data) {
  var url = baseUrl + '/oaflow/forminstance/search';
  return axios.post(url, data);
}

///oaflow/forminstance/submit 提交表单实例，启动流程
api.QBJforminstanceSubmit = function (data) {
  var url = baseUrl + '/oaflow/forminstance/submit';
  return axios.post(url, data);
}

///oaflow/form/add 添加表单
api.QBJformAdd = function (data) {
  var url = baseUrl + '/oaflow/form/add';
  return axios.post(url, data);
}

///oaflow/form/count 获取登录用户可见的有效表单列表数量,按照表单分组聚合
api.QBJformCount = function (data) {
  var url = baseUrl + '/oaflow/form/count';
  return axios.post(url, data);
}

///oaflow/form/delete 删除表单（逻辑删除）
api.QBJformDelete = function (data) {
  var url = baseUrl + '/oaflow/form/delete';
  return axios.post(url, data);
}

///oaflow/form/detail 获取登录用户可见的有效表单详情
api.QBJformDetail = function (data) {
  var url = baseUrl + '/oaflow/form/detail';
  return axios.post(url, data);
}

// 获取登录用户可见的有效表单详情
api.QBJOaflowFormAvailable_detail = function (data) {
  var url = baseUrl + '/oaflow/form/available_detail';
  return axios.post(url, data);
}

///oaflow/form/list 获取登录用户可见的有效表单列表
api.QBJformList = function (data) {
  var url = baseUrl + '/oaflow/form/list';
  return axios.post(url, data);
}
// /oaflow/form/search_can_be_associated 搜索可被关联的表单分组
api.QBAssociated = function (data) {
  var url = baseUrl + '/oaflow/form/search_can_be_associated';
  return axios.post(url, data, { apiType: 1 });
}
//
api.QBAssociatedFormList = function (data) {
  var url = baseUrl + '/oaflow/forminstance/list_associated_forminstance';
  return axios.post(url, data, { apiType: 1 });
}
////oaflow/form/list_by_gorupid 获取登录用户可见的有效表单列表
api.QBJformListById = function (data) {
  var url = baseUrl + '/oaflow/form/list_by_gorupid';
  return axios.post(url, data);
}

///oaflow/form/listall 管理员获取全部有效表单列表
api.QBJformListall = function (data) {
  var url = baseUrl + '/oaflow/form/listall';
  return axios.post(url, data);
}

///oaflow/form/search 表单搜索
api.QBJformSearch = function (data) {
  var url = baseUrl + '/oaflow/form/search';
  return axios.post(url, data);
}

///oaflow/form/set_visible_range 设置表单可见范围
api.QBJformSVR = function (data) {
  var url = baseUrl + '/oaflow/form/set_visible_range';
  return axios.post(url, data);
}

///oaflow/form/sort 表单排序
api.QBJformSort = function (data) {
  var url = baseUrl + '/oaflow/form/sort';
  return axios.post(url, data);
}

///oaflow/form/update 更新表单,表单不允许更新，更新操作等于创建一个新表单
api.QBJformUpdate = function (data) {
  var url = baseUrl + '/oaflow/form/update';
  return axios.post(url, data);
}

///oaflow/formapplication/export 导出表单申请列表
api.QBJformapplicationExport = function (data) {
  var url = baseUrl + '/oaflow/formapplication/export';
  return axios.post(url, data, { responseType: 'blob' });
}

// /oaflow/forminstance/status/list
api.QBJForminstanceStatusList = function (data) {
  var url = baseUrl + '/oaflow/forminstance/status/list';
  return axios.post(url, data);
}


//oaflow/formapplication/list 获取表单申请列表
api.QBJformapplicationList = function (data) {
  var url = baseUrl + '/oaflow/formapplication/list';
  return axios.post(url, data);
}

///oaflow/formicon/list 获取表单图标资源
api.QBJformiconList = function (data) {
  var url = baseUrl + '/oaflow/formicon/list';
  return axios.post(url, data);
}

///oaflow/form/set_available 启用表单
api.QBJset_available = function (data) {
  var url = baseUrl + '/oaflow/form/set_available';
  return axios.post(url, data);
}

///oaflow/form/set_unavailable 停用表单
api.QBJset_unavailable = function (data) {
  var url = baseUrl + '/oaflow/form/set_unavailable';
  return axios.post(url, data);
}

///oaflow/processdef/getDefaultCcUsers 查看流程抄送人信息
api.DCprocessdefGetDefaultCcUsers = function (data) {
  var url = baseUrl + '/oaflow/processdef/getDefaultCcUsers';
  return axios.post(url, data);
}

///oaflow/processdef/getDefaultCcUsers 查看流程抄送人信息
api.ZZDCommonPdf = function (data) {
  var url = baseUrl + '/oaflow/common/pdf';
  return axios.post(url, data, {
    responseType: "blob"
  });
}

///oaflow/forminstance/apply/urge 我的申请-催办
api.TGApplyUrge = function (data) {
  var url = baseUrl + '/oaflow/forminstance/apply/urge';
  return axios.post(url, data);
}

///oaflow/forminstance/validate_form 验证表单是否有效
api.QBJForminstanceValidate_form = function (data) {
  var url = baseUrl + '/oaflow/forminstance/validate_form';
  return axios.post(url, data);
}

///oaflow/common/imgpdf 图片导出PDF
api.ZZDCommonImgpdf = function (data, name) {
  var url = baseUrl + '/oaflow/common/imgpdf?name=' + name;
  var formFile = new FormData();
  formFile.append("file", data);
  return axios.post(url, formFile, {
    responseType: "blob"
  }, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
}
//oaflow/form/nongrouped_search 表单搜索
api.QBJNongrouped_search = function (data) {
  var url = baseUrl + '/oaflow/form/nongrouped_search';
  return axios.post(url, data);
}

// /oabase/utils/upload/preview
api.QBUploadPreview = function (data) {
  var url = baseUrl + '/oabase/utils/upload/preview';
  return axios.post(url, data);
}

api.TGCommonuploadPDF2 = function (data, type) {
  if (Number(data.size / 1024 / 1024) >= 100) {
    return new Promise(function (res, rej) {
      rej({ message: '文件不能大于100MB' })
    })
  } else {
    if (type !== 0) type = type || 3;
    var url = baseUrl + "/oabase/utils/common/uploadPDF?system=1&type=" + type;
    var formFile = new FormData();
    formFile.append("files", data);
    return axios.post(url, formFile, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    });
  }
}

api.TGUtilsDownFile = function (data) {
  var url = baseUrl + '/oabase/utils/downFile?url=' + data.url;
  return axios.post(url, data, { responseType: 'blob' });
}

api.TGBulletinTypeLeftlist = function (data) {
  var url = baseUrl + '/oabase/bulletin/type/leftlist';
  return axios.post(url, data);
}

// 查询考勤组接口
api.attendanceList = function (data) {
  var url = baseUrl + '/oabase/attendance/list';
  return axios.post(url, data);
}
// 删除考勤组
api.attendanceDel = function (data) {
  var url = baseUrl + '/oabase/attendance/del';
  return axios.post(url, data);
}
// 新增考勤组
api.attendanceAdd = function (data) {
  var url = baseUrl + '/oabase/attendance/add';
  return axios.post(url, data);
}
// 更新考勤组接口【田果】
api.attendanceUpdate = function (data) {
  var url = baseUrl + '/oabase/attendance/update';
  return axios.post(url, data);
}
// 更新考勤组时查询考勤组详情-web接口【田果】
api.attendanceUpdateDetail = function (data) {
  var url = baseUrl + '/oabase/attendance/update/detail';
  return axios.post(url, data);
}
// 检验考勤人员是否存其他考勤组中
api.existUser = function (data) {
  var url = baseUrl + '/oabase/attendance/exist/user';
  return axios.post(url, data);
}

// 检验考勤人员是否存其他考勤组中2
api.updateStaff = function (data) {
  var url = baseUrl + '/oabase/clock/update/staff';
  return axios.post(url, data);
}

// 查询考勤 按月统计
api.monthAccount = function (data) {
  var url = baseUrl + '/oabase/attendance/Month/account';
  return axios.post(url, data);
}
// web-某天考勤详情接口【田果】
api.attendanceDetail1 = function (data) {
  var url = baseUrl + '/oabase/attendance/detail1';
  return axios.post(url, data);
}
// 管理员更改考勤结果接口【田果】
api.attendanceUpdateRecord = function (data) {
  var url = baseUrl + '/oabase/attendance/update/record';
  return axios.post(url, data);
}
// 导出考勤每月统计excel接口【田果】
api.monthAccountExport = function (data) {
  var url = baseUrl + '/oabase/attendance/month/account/export';
  return axios.post(url, data, { responseType: 'blob' });
}
// 查询考勤 按日统计
api.dailyAccount = function (data) {
  var url = baseUrl + '/oabase/attendance/daily/account';
  return axios.post(url, data);
}
// 导出考勤每日统计excel接口
api.dailyAccountExport = function (data) {
  var url = baseUrl + '/oabase/attendance/daily/account/export';
  return axios.post(url, data, { responseType: 'blob' });
}

// 查询所有部门人员节点信息(附带离职人员)【杨锐】
api.bulletinOrgNodeLeave = function (data) {
  var url = baseUrl + '/oabase/bulletin/orgNodeLeave';
  return axios.post(url, data);
}

// 查询打卡时间接口【田果】
api.attendanceClockOff = function (data) {
  var url = baseUrl + '/oabase/attendance/clock/off';
  return axios.post(url, data);
}
// 导出打卡时间excel接口【田果】
api.clockOffExport = function (data) {
  var url = baseUrl + '/oabase/attendance/clock/off/export';
  return axios.post(url, data, { responseType: 'blob' });
}
// 查询原始记录接口【田果】
api.originalRecord = function (data) {
  var url = baseUrl + '/oabase/attendance/original/record';
  return axios.post(url, data);
}
// 导出原始记录excel接口【田果】
api.originalRecordExport = function (data) {
  var url = baseUrl + '/oabase/attendance/original/record/export';
  return axios.post(url, data, { responseType: 'blob' });
}


// 获取服务器时间接口【田果】
api.attendanceTime = function (data) {
  var url = baseUrl + '/oabase/attendance/time';
  return axios.post(url, data);
}

// /oabase/org/departLeaveUser 查看离职人员名单接口【杨锐】
api.departLeaveUser = function (data) {
  var url = baseUrl + '/oabase/org/departLeaveUser';
  return axios.post(url, data);
}

// /oabase/org/orgTreeLeaveUser查询部门树和设置默认角色接口(离职人员选取专用)【杨锐】
api.orgTreeLeaveUser = function (data) {
  var url = baseUrl + '/oabase/org/orgTreeLeaveUser';
  return axios.post(url, data);
}

// /oabase/org/startUsingDepartLeaveUser启用离职人员名单接口【杨锐】
api.startUsingDepartLeaveUser = function (data) {
  var url = baseUrl + '/oabase/org/startUsingDepartLeaveUser';
  return axios.post(url, data);
}

// /oabase/org/orgStartUsingSearch 根据部门名称关键字查询通讯录接口【杨锐】
api.orgStartUsingSearch = function (data) {
  var url = baseUrl + '/oabase/org/orgStartUsingSearch';
  return axios.post(url, data, { apiType: 1 });
}

// oaflow/forminstance/list_applicant_forminstance 分页获取申请人提交的表单实例列表
api.applicantForminstance = function (data) {
  var url = baseUrl + '/oaflow/forminstance/list_applicant_forminstance';
  return axios.post(url, data, { apiType: 1 });
}

// /oaflow/forminstance/search_draft暂存（草稿）表单搜索
api.searchDraft = function (data) {
  var url = baseUrl + '/oaflow/forminstance/search_draft';
  return axios.post(url, data);
}
// /oaflow/forminstance/add_draft暂存表单（草稿）
api.addDraft = function (data) {
  var url = baseUrl + '/oaflow/forminstance/add_draft';
  return axios.post(url, data);
}
// /oaflow/forminstance/delete_draft删除暂存表单（草稿）
api.deleteDraft = function (data) {
  var url = baseUrl + '/oaflow/forminstance/delete_draft';
  return axios.post(url, data);
}
// /oaflow/forminstance/draft_detail暂存（草稿）表单详情
api.draftDetail = function (data) {
  var url = baseUrl + '/oaflow/forminstance/draft_detail';
  return axios.post(url, data);
}
// /oaflow/forminstance/list_resubmit_record 获取表单重提交列表
api.rejectList = function (data) {
  var url = baseUrl + '/oaflow/forminstance/list_resubmit_record';
  return axios.post(url, data);
}

// /oabase/approvalRole/add 审批角色新增接口【田果】
api.approvalRoleAdd = function (data) {
  var url = baseUrl + '/oabase/approvalRole/add';
  return axios.post(url, data);
}
// /oabase/approvalRole/delete 审批角色删除接口【田果】
api.approvalRoleDelete = function (data) {
  var url = baseUrl + '/oabase/approvalRole/delete';
  return axios.post(url, data);
}
// /oabase/approvalRole/update 审批角色修改接口【田果】
api.approvalRoleUpdate = function (data) {
  var url = baseUrl + '/oabase/approvalRole/update';
  return axios.post(url, data);
}
// /oabase/approvalRoleUser/add 审批角色新增人员接口【田果】
api.approvalRoleUserAdd = function (data) {
  var url = baseUrl + '/oabase/approvalRoleUser/add';
  return axios.post(url, data);
}
// /oabase/approvalRoleUser/delete 审批角色人员删除接口【田果】
api.approvalRoleUserDelete = function (data) {
  var url = baseUrl + '/oabase/approvalRoleUser/delete';
  return axios.post(url, data);
}
// /oabase/approvalRoleUser/list 审批角色成员列表接口【田果】
api.approvalRoleUserList = function (data) {
  var url = baseUrl + '/oabase/approvalRoleUser/list';
  return axios.post(url, data);
}
// /oabase/approvalRoleUser/scope 审批角色人员设置范围接口【田果】
api.approvalRoleUserScope = function (data) {
  var url = baseUrl + '/oabase/approvalRoleUser/scope';
  return axios.post(url, data);
}
// /oabase/roleGroup/add 角色组新增接口【田果】
api.roleGroupAdd = function (data) {
  var url = baseUrl + '/oabase/roleGroup/add';
  return axios.post(url, data);
}
// /oabase/roleGroup/delete 角色组删除接口【田果】
api.roleGroupDelete = function (data) {
  var url = baseUrl + '/oabase/roleGroup/delete';
  return axios.post(url, data);
}
// /oabase/roleGroup/list 角色组列表查询接口【田果】
api.roleGroupList = function (data) {
  var url = baseUrl + '/oabase/roleGroup/list';
  return axios.post(url, data);
}
// /oabase/roleGroup/update 角色组修改接口【田果】
api.roleGroupUpdate = function (data) {
  var url = baseUrl + '/oabase/roleGroup/update';
  return axios.post(url, data);
}

// /oabase/approvalRole/search审批角色搜索列表接口【田果】
api.approvalRoleSearch = function (data) {
  var url = baseUrl + '/oabase/approvalRole/search';
  return axios.post(url, data, { apiType: 1 });
}

// /oaflow/approve/withdraw 流程实例撤回
api.withdraw = function (data) {
  var url = baseUrl + '/oaflow/approve/withdraw';
  return axios.post(url, data);
}

// /oabase/library/authorizeLibrary 文件夹授权【杨锐】
api.authorizeLibrary = function (data) {
  var url = baseUrl + '/oabase/library/authorizeLibrary';
  return axios.post(url, data);
}
// /oabase/library/common/upload 文件上传权限接口【杨锐】
api.libraryUpload = function (data, id, type) {
  console.log(data)
  if (Number(data.size / 1024 / 1024) >= 100) {
    return new Promise(function (res, rej) {
      rej({ message: '文件不能大于100MB' })
    })
  }else if (!(/\.(doc|docx|xlsx|xls|pdf|zip|rar)$/.test(data.name.toLowerCase()))) {
    return new Promise(function (res, rej) {
      rej({ message: '文件只能上传word,excel,zip,rar,pdf' })
    })
  }else {
    if (type !== 0) type = type || 3;
    var url = baseUrl + "/oabase/library/common/upload?system=1&type=" + type;
    var formFile = new FormData();
    formFile.append("files", data);
    formFile.append("libraryId ", id);
    return axios.post(url, formFile, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
// /oabase/library/create 新建文件夹【taojinsen】
api.libraryCreate = function (data) {
  var url = baseUrl + '/oabase/library/create';
  return axios.post(url, data);
}
// /oabase/library/deleteLibrary 删除文件夹权限接口【杨锐】
api.deleteLibrary = function (data) {
  var url = baseUrl + '/oabase/library/deleteLibrary';
  return axios.post(url, data);
}
// /oabase/library/downFile 下载文件权限接口【杨锐】
api.libraryDownFile = function (data) {
  var url = baseUrl + '/oabase/library/downFile?url=' + data.url + '&libraryId=' + data.libraryId;
  return axios.post(url, data, { responseType: 'blob' });
}
// /oabase/library/list 文库列表查询【taojinsen】
api.libraryList = function (data) {
  var url = baseUrl + '/oabase/library/list';
  return axios.post(url, data);
}
// /oabase/library/rename 文件重命名权限接口【杨锐】
api.libraryRename = function (data) {
  var url = baseUrl + '/oabase/library/rename';
  return axios.post(url, data);
}
// /oabase/library/saveLibrary 文件上传保存【杨锐】
api.saveLibrary = function (data) {
  var url = baseUrl + '/oabase/library/saveLibrary';
  return axios.post(url, data);
}

// /oabase/library/searchLibraryTree 展示当前拥有文件人员权限接口【杨锐】
api.searchLibraryTree = function (data) {
  var url = baseUrl + '/oabase/library/searchLibraryTree';
  return axios.post(url, data);
}

// /oabase/library/queryhLibraryLevel 点击面包屑返回对应文件夹接口【杨锐】
api.queryhLibraryLevel = function (data) {
  var url = baseUrl + '/oabase/library/queryhLibraryLevel';
  return axios.post(url, data);
}

// /oabase/report/create 工作汇报提交【taojinsen】
api.reportCreate = function (data) {
  var url = baseUrl + '/oabase/report/create';
  return axios.post(url, data);
}

// /oabase/report/detail工作汇报详情【taojinsen】
api.reportDetail = function (data) {
  var url = baseUrl + '/oabase/report/detail';
  return axios.post(url, data);
}

// /oabase/report/list 查看汇报列表查询【taojinsen】
api.reportList = function (data) {
  var url = baseUrl + '/oabase/report/list';
  return axios.post(url, data);
}

// /oabase/report/submit-list 已提交汇报列表查询【taojinsen】
api.reportSubmitList = function (data) {
  var url = baseUrl + '/oabase/report/submit-list';
  return axios.post(url, data);
}

/* ++++++++++++++ OA二期接口 ++++++++++++++*/



export default api;




// WEBPACK FOOTER //
// ./src/api/index.js